import React from 'react';
import { Button, Menu, MenuButton, MenuList, MenuItem, HStack, Text } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const languages = [
    { code: 'tr', name: '', flag: '🇹🇷' },
    { code: 'en', name: '', flag: '🇺🇸' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <Menu>
      <MenuButton as={Button} rightIcon={<ChevronDownIcon />} variant="ghost" size="sm">
        <HStack spacing={2}>
          <Text fontSize="lg">{currentLanguage.flag}</Text>
          <Text>{currentLanguage.name}</Text>
        </HStack>
      </MenuButton>
      <MenuList>
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => changeLanguage(language.code)}
            bg={i18n.language === language.code ? 'blue.50' : 'transparent'}
          >
            <HStack spacing={2}>
              <Text fontSize="lg">{language.flag}</Text>
              <Text>{language.name}</Text>
            </HStack>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LanguageSwitcher;